import { t } from 'i18next'

export const ROOT = '/'
export const NOT_FOUND = '/404'
export const LOGIN = '/login'

export const MONITORING = '/monitoring'
export const VIOLATION_LOG = '/violation-log'

export const getRouteName = (route) => {
    switch (route) {
        case MONITORING:
            return t('routes.monitoring')
        case VIOLATION_LOG:
            return t('routes.violationLog')
        case NOT_FOUND:
            return t('routes.notFound')
        default:
            return ''
    }
}
